<template>
    <div class="ml-2">
        <b-button variant="primary" @click.stop="abrirModal()">
            <i class="fa fa-user"></i> Selecionar Analista Gestor
        </b-button>
        <b-modal :visible="mostrarModal" @hide="fecharModal" hide-footer title="Selecionar Gestor Responsável" centered
            size="md">
            <b-alert v-if="erros.length" variant="danger" show>
                <div v-for="(erro, idx) in erros" :key="idx">{{ erro }}</div>
            </b-alert>

            <div v-if="carregandoGestores" class="text-center">
                <b-spinner label="Carregando gestores..."></b-spinner>
                <p>Carregando gestores...</p>
            </div>
            <div v-else>
                <div class="mb-3">
                    <p class="text-muted mb-2">
                        <i class="fa fa-info-circle"></i>
                        Para prosseguir com a análise desta requisição, é necessário selecionar um gestor responsável.
                    </p>
                    <p class="text-muted small">
                        O gestor selecionado será responsável pela análise e aprovação desta solicitação de requisição.
                    </p>
                </div>

                <b-form-group label="Gestor Responsável" label-for="gestor-select" label-class="required">
                    <model-list-select :list="gestores" option-text="nome" option-value="codFuncionario"
                        v-model="codGestor">
                    </model-list-select>
                </b-form-group>
            </div>

            <div class="d-flex justify-content-end">
                <b-button variant="secondary" class="mr-2" @click="fecharModal">
                    Cancelar
                </b-button>
                <b-button variant="success" :disabled="!codGestor || carregandoGestores" @click="selecionarGestor">
                    Selecionar
                </b-button>
            </div>
        </b-modal>
    </div>
</template>

<script>
import RequisicoesServicos from './RequisicoesServicos'
import { ModelListSelect } from 'vue-search-select'


export default {
    props: {
        requisicao: {
            type: Object,
            required: true
        }
    },
    components: {
        ModelListSelect
    },

    data() {
        return {
            erros: [],
            mostrarModal: false,
            carregandoGestores: false,
            gestores: [],
            gestorSelecionado: null,
            codGestor: null
        }
    },

    computed: {
        gestoresOptions() {
            return this.gestores.map(gestor => ({
                value: gestor.codFuncionario,
                text: gestor.nome
            }))
        }
    },

    methods: {
        fecharModal() {
            this.mostrarModal = false
            this.gestorSelecionado = null
            this.erros = []
        },

        abrirModal() {
            this.mostrarModal = true
            this.obterGestores()
        },

        obterGestores() {
            this.carregandoGestores = true
            this.erros = []

            RequisicoesServicos.obterSolicitantes().then((response) => {
                this.carregandoGestores = false
                if (response) {
                    if (response.success) {
                        this.gestores = response.data.filter(gestor => gestor.email != null)
                    } else {
                        this.erros = response.errors || ['Erro ao carregar gestores']
                    }
                } else {
                    this.erros = ['Erro ao carregar gestores']
                }
            }).catch(() => {
                this.carregandoGestores = false
                this.erros = ['Erro ao carregar gestores']
            })
        },

        selecionarGestor() {
            this.$store.dispatch('addRequest')

            const gestorEscolhido = this.gestores.find(gestor => gestor.codFuncionario === this.codGestor)
            console.log(this.requisicao)
            if (gestorEscolhido) {
                RequisicoesServicos.enviarGestorSolicitacao(this.requisicao.idRequisicao, this.codGestor)
                    .then((response) => {
                        if (response.success) {
                            this.$toast.success(
                                `Gestor ${gestorEscolhido.nome} selecionado com sucesso!`,
                                'Sucesso',
                                this.$toastConfig.success
                            )
                        } else {
                            this.$toast.error(
                                `Erro ao selecionar gestor ${gestorEscolhido.nome}.`,
                                'Erro',
                                this.$toastConfig.error
                            )
                        }
                        this.$store.dispatch('removeRequest')
                        this.fecharModal()
                        this.$emit('obterRequisicao')
                    })
            }
        }
    }
}
</script>
